<div class="main-container lg-view">
	<app-loader *ngIf="isLoading" [hasTransparency]="true"></app-loader>
	<div class="header">
		<h3 class="header-details">Documents</h3>
		<div class="search-wrapper">
			<form [formGroup]="searchForm">
				<div class="filter-search">
					<mat-form-field id="searchKeyword">
						<mat-label>Search</mat-label>
						<input matInput type="text" formControlName="searchKeyword">
						<button mat-button *ngIf="searchForm.get('searchKeyword')?.value" matSuffix mat-icon-button
							aria-label="Clear" (click)="onSearchClear()">
							<mat-icon>close</mat-icon>
						</button>
					</mat-form-field>
				</div>
				<div class="filter-container-wrapper">
					<div class="filter-container">
						<div class="filter-item-label">Favorites only</div>
						<mat-slide-toggle formControlName="displayFavoritesOnly" color="primary"></mat-slide-toggle>
					</div>
					<div class="filter-container">
						<div class="filter-item-label">Only with No Docs</div>
						<mat-slide-toggle formControlName="displayOnlyNoDocs" color="primary"></mat-slide-toggle>
					</div>
				</div>
				<hr />
			</form>
		</div>
	</div>
	<div class="body">
		<div class="fields-wrapper">
			<div class="no-data" *ngIf="fieldsAttachments.length == 0">
				No records found.
			</div>
			<div class="field-wrapper" *ngFor="let field of fieldsAttachments">
				<div class="field-details-wrapper">
					<div class="field-name">{{field.fieldName}}</div>
					<div class="block-description">
						<span>{{field.blockName}}</span>
						<span *ngIf="field.blockValue">[{{field.blockValue}}]</span>
					</div>
					<div class="section-group">{{field.groupName}}</div>
					<div class="form-name">{{field.formName}}</div>
				</div>
				<div class="field-actions-wrapper">
					<button mat-icon-button (click)="onDocumentsClick(field)">
						<mat-icon
							[svgIcon]="field.documentCount > 0 ? 'critical_folder_checked' : 'critical_folder'"></mat-icon>
					</button>
					<button mat-icon-button (click)="onFavoriteClick(field)">
						<mat-icon *ngIf="field.isFavorite; else not_favorite" style="color: #ffc10a;">star</mat-icon>
						<ng-template #not_favorite>
							<mat-icon>star_outline</mat-icon>
						</ng-template>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="actions-container md-view">
	<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
</div>

<generic-modal #fieldDocumentErrorModal [hideOnBackdropClick]="true" [overlayClass]="'field-document-error-modal'">
	<ng-template #modalBody>
		<div class="main-container">
			<ng-container>
				<p>Unable to update the attachment. <br /> Please try again!</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button (click)="closeFieldDocumentErrorModal()">Ok</button>
	</ng-template>
</generic-modal>